import { Component, OnInit, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { SearchStateParameters, StateView } from '@api-proxies';
import { StateService } from '@services/http/clients/state.service';
import { GenericTypeAheadDropdownComponent } from 'ngx-lib';
import { FormEditorBase, createValueAccessorProvider } from '../base/form-editor-base';

@Component({
    selector: 'app-state-form-editor',
    templateUrl: './state-form-editor.component.html',
    styleUrls: ['./state-form-editor.component.scss'],
    providers: [createValueAccessorProvider(StateFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericTypeAheadDropdownComponent]
})
export class StateFormEditorComponent extends FormEditorBase<StateView[]> implements OnInit {
    value = input<StateView>();
    readonly = input<boolean>(false);
    placeholderText = input<string>('Select State');
    labelText = input<string>('State');

    private readonly stateService = inject(StateService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.items.set([]);
    }

    selectedItem(): StateView | undefined {
        const items = this.selectedItems();
        return items && items.length > 0 ? items[0] : undefined;
    }

    onSelectedItemChange(item?: StateView): void {
        if (item) {
            this.onSelectedItemsChange([item]);
        } else {
            this.onSelectedItemsChange([]);
        }
    }

    protected override async onEntityTextChange(text: string): Promise<void> {
        if (!text) {
            this.items.set([]);
            return;
        }

        const states = await this.stateService.search({
            filterText: text
        } as SearchStateParameters);

        this.items.set(states);
    }

    protected override mapSelectedItemsToValue(): StateView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: StateView[]): any[] {
        return value || [];
    }
}
